// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/views/partner/crud/addTournament/index.css
// module id = 2643
// module chunks = 0